module.exports = __webpack_public_path__ + "static/media/who-loves-your-show.39f7dede.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/destination-prompt/who-loves-your-show.png
// module id = 714
// module chunks = 0